import { Injectable } from '@angular/core';
import { FilterRule } from '../api/api-clientInformation';

@Injectable({
  providedIn: 'root',
})
export class DisplayStorageService {
  displayedColumns: string[] = [];

  constructor() {

    window.addEventListener('beforeunload', () => {
      const isReportReload = localStorage.getItem('reportReload');
      if (!isReportReload) {
        localStorage.removeItem('portfolio-backlog-view');
        localStorage.removeItem('portfolio-view');
        localStorage.removeItem('forecast-view');
        localStorage.removeItem('cutline-view');
        localStorage.removeItem('cutline-scenarios-view');
        localStorage.removeItem('myportfolio-view');
        localStorage.removeItem('breakinout-approval-view');
        localStorage.removeItem('linked-records-view');
        localStorage.removeItem('plan-vs-fact-view');
        localStorage.removeItem('detail-forecast-view');
        localStorage.removeItem('job-log-detail-view');
        localStorage.removeItem('capex-cutline-view');
        localStorage.removeItem('capex-prioritization-view');
        localStorage.removeItem('new-projects-break-in-view');
        localStorage.removeItem('budget-change-view');
        localStorage.removeItem('tfm-cutline-view');

        localStorage.removeItem('filter_break_in_out');
        localStorage.removeItem('filter_myapprovals');
        localStorage.removeItem('filter_forecasts');
        localStorage.removeItem('filter_myportfolio');
        localStorage.removeItem('filter_portfolio_backlog');
        localStorage.removeItem('filter_initiatives');
        localStorage.removeItem('filter_linked_records');
        localStorage.removeItem('filter_plan_vs_fact');
        localStorage.removeItem('filter_detail-forecast');
        localStorage.removeItem('filter_gantt_chart');
        localStorage.removeItem('page_gantt_chart');
        localStorage.removeItem('gantt_chart_zoomLevel');
        localStorage.removeItem('gantt_chart_selectedYear');
        localStorage.removeItem('filter_capex_prioritization');
        localStorage.removeItem('filter_new_projects_break_in');
        localStorage.removeItem('filter_budget_change');


      }else{
        localStorage.removeItem('reportReload');
      }
    });
  }

  setDisplayedColumns(storageKey: string, columns: string[]) {
    localStorage.setItem(storageKey, JSON.stringify(columns));
  }

  getDisplayedColumns(storageKey: string): string[] {
    return JSON.parse(localStorage.getItem(storageKey) || '[]');
  }

  setFilters(storageKey: string, columns: FilterRule[]) {
    localStorage.setItem(storageKey, JSON.stringify(columns));
  }

  clearFilters(storageKey: string) {
    localStorage.removeItem(storageKey);
  }

  getFilters(storageKey: string): string {
    return localStorage.getItem(storageKey) || '';
  }

  hasActiveFilter(storageKey: string): boolean {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return false;
    try {
      const filters = JSON.parse(raw);
      return Array.isArray(filters) && filters.length > 0;
    } catch {
      return false;
    }
  }

  setForecastRevision(forecastRevisionPk: number) {
    localStorage.setItem('selectedForecastRevision', String(forecastRevisionPk));
  }

  getForecastRevision(): number {
    const selectedForecastRevisionPk = localStorage.getItem('selectedForecastRevision');
    return selectedForecastRevisionPk === null
      ? 0
      : Number(selectedForecastRevisionPk);
  }

  setShowInK(componentKey: string, value: boolean) {
    localStorage.setItem(`${componentKey}-showInK`, JSON.stringify(value));
  }

  getShowInK(componentKey: string, defaultValue = false): boolean {
    const stored = localStorage.getItem(`${componentKey}-showInK`);
    return stored !== null ? JSON.parse(stored) : defaultValue;
  }

  setPage(storageKey: string, page: number) {
    localStorage.setItem(storageKey, String(page));
  }

  getPage(storageKey: string): number {
    const stored = localStorage.getItem(storageKey);
    return stored !== null ? Number(stored) : 0;
  }
}
